import { useCallback, useEffect, useState, forwardRef } from 'react';

export const DateTooltip = forwardRef(
  ({ children, text, enabled, dataTestId, className }, ref) => {
    const [isVisible, setIsVisible] = useState(false);

    const handleOpen = useCallback(() => setIsVisible(true), []);
    const handleClose = useCallback(() => setIsVisible(false), []);
    useEffect(() => {
      let parent = ref.current && ref.current.parentElement;
      if (parent) {
        parent.style = 'z-index: 10';
        parent.addEventListener('mouseenter', handleOpen);
        parent.addEventListener('mouseleave', handleClose);
      }
      return () => {
        if (parent) {
          parent.style = '';
          parent.removeEventListener('mouseenter', handleOpen);
          parent.removeEventListener('mouseleave', handleClose);
          parent = null;
        }
      };
    }, [ref, handleClose, handleOpen]);

    const show = Boolean(isVisible && text && enabled);
    const positionStyles = `mb-3 bottom-full left-[50%] translate-x-[-50%]`;
    return (
      <span
        ref={ref}
        className={`relative flex items-center ${className}`}
        data-testid={dataTestId}
      >
        <span>{children}</span>
        {show && (
          <div
            className={`absolute -translate-y-1.5 px-2 py-1 border md:whitespace-nowrap border-slate-700 bg-white text-slate-700 max-md:leading-[calc(18_*_100vw_/_390)] max-md:text-[calc(14_*_100vw_/_390)] md:text-base rounded-[4px] ${positionStyles}`}
          >
            {text}
          </div>
        )}
      </span>
    );
  },
);

DateTooltip.displayName = 'DateTooltip';
